<template lang="pug">
  v-card.mb-3
    .list-mobile__top.list-mobile__top--offset-md
      .list-mobile__title {{ item.name | shortstr }}
    .list-mobile__content
      .list-mobile__item
        .list-mobile__item-label {{ 'base.date' | translate }}
        .list-mobile__item-value {{ item.planned_on | date }}
      .list-mobile__item
        .list-mobile__item-label {{ 'base.status' | translate }}
        .list-mobile__status(:class="statuses") {{ `status.${item.status}` | translate }}
      .list-mobile__item
        .list-mobile__item-label {{ 'base.period' | translate }}
        .list-mobile__item-value {{ item.schedule_loading.name }}
      .list-mobile__item
        .list-mobile__item-label {{ 'base.ration' | translate }}
        .list-mobile__item-value {{ item.schedule_ration.name }}
      .list-mobile__item
        .list-mobile__item-label {{ 'base.animal_groups' | translate }}
        .list-mobile__item-value {{ groupList | shortstr }}
      .list-mobile__item
        .list-mobile__item-label {{ 'modals.ration_info.third' | translate }}
        .list-mobile__item-value {{ totalPlannedWeight | rounding }} / {{ totalFactualdWeight | rounding }}
      .list-mobile__item
        .list-mobile__item-label {{ 'base.deviation' | translate }}. [{{ 'base.kg' | translate }} / %]
        .list-mobile__item-value {{ totalWeightDeviation | rounding }} / {{ totalPercentDeviation | rounding }}
      .list-mobile__item
        .list-mobile__item-label {{ 'base.weight' | translate }} [{{ 'base.kg' | translate }}] {{ 'base.plan_fact' | translate }}
        .list-mobile__item-value {{ totalPlannedDryWeight | rounding }} / {{ totalFactualDryWeight | rounding }}
      .list-mobile__item
        .list-mobile__item-label {{ 'base.loading_time' | translate }} [{{ 'base.min' | translate }}]
        .list-mobile__item-value {{ item.mix_time | sectomin }}
      .list-mobile__item
        .list-mobile__item-label {{ 'base.operator' | translate }}
        .list-mobile__item-value {{ item.worker || '-' }}
</template>

<script>
const totalPlannedWeightReducer = (acc, item) => (acc += item.plan_weight)
const totalFactualdWeightReducer = (acc, item) => (acc += item.fact_weight)
const totalPercentDeviationReducer = (acc, item) => (acc += item.diff_in_percent)
const totalWeightDeviationReducer = (acc, item) => (acc += Math.round(item.fact_weight - item.plan_weight))
const totalPlannedDryWeightReducer = (acc, item) => (acc += item.plan_weight * item.coefficient / 100 / item.animal_count)
const totalFactualDryWeightReducer = (acc, item) => (acc += item.fact_weight * item.coefficient / 100 / item.animal_count)

export default {
  name: 'MixerLoadsItemMobile',

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    statuses () {
      return {
        'list-mobile__status--waited': this.item.status === 'waited',
        'list-mobile__status--loaded': this.item.status === 'loaded',
        'list-mobile__status--uploaded': this.item.status === 'uploaded',
        'list-mobile__status--in-process': this.item.status === 'in_process',
        'list-mobile__status--out-process': this.item.status === 'out_process',
      }
    },

    groupList () {
      return this.item.schedule_groups_list.names.join(', ')
    },

    totalPlannedWeight () {
      return this.item.schedule_groups
        .reduce(totalPlannedWeightReducer, 0)
    },

    totalFactualdWeight () {
      return this.item.schedule_groups
        .reduce(totalFactualdWeightReducer, 0)
    },

    totalPercentDeviation () {
      return this.item.schedule_groups
        .reduce(totalPercentDeviationReducer, 0)
    },

    totalWeightDeviation () {
      return this.item.schedule_groups
        .reduce(totalWeightDeviationReducer, 0)
    },

    totalPlannedDryWeight () {
      return this.item.schedule_groups
        .reduce(totalPlannedDryWeightReducer, 0)
    },

    totalFactualDryWeight () {
      return this.item.schedule_groups
        .reduce(totalFactualDryWeightReducer, 0)
    },
  }
}
</script>
